import { ColumnKey, RoleManagementFormValues } from "./types";
import * as Yup from "yup";

export const apiEndpoint = `/users`;

export const ColumnOptions: { value: ColumnKey; label: string }[] = [
  { value: "id", label: "ID" },
  { value: "name", label: "Name" },
  { value: "email", label: "Email" },
  { value: "googleId", label: "Google ID" },
  { value: "role", label: "Role" },
  { value: "updatedAt", label: "Updated At" },
];

export const DefaultHiddenColumns: ColumnKey[] = ["id", "updatedAt"];

export const AllowedSortFields = ["name", "email", "googleId", "role"] as const;

export const RoleManagementFormInitialValues: RoleManagementFormValues = {
  name: "",
  email: "",
  googleId: "",
  role: "",
};

export const RoleManagementFormValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email address")
    .required("Email is required"),
  googleId: Yup.string().trim().required("Google ID is required"),
  role: Yup.string().trim().required("Role is required"),
});

export const RoleManagementFormFields = [
  { name: "name", label: "Name", type: "text" },
  { name: "email", label: "Email", type: "email" },
  { name: "googleId", label: "Google ID", type: "text" },
  { name: "role", label: "Role", type: "dropdown" },
];
